/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ship/fighter_2': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<circle pid="0" cx="2" cy="2" r="2"/><path pid="1" d="M13 18.5h6l-3-9z"/><path pid="2" d="M19 19h-6a.5.5 0 010-1h6c.275 0 .5.225.5.5s-.225.5-.5.5z"/><path pid="3" d="M19 15.5h1v4h-1z"/><path pid="4" d="M19.5 19.997a.5.5 0 01-.5-.5v-2a.5.5 0 011 0v2a.5.5 0 01-.5.5zM12.5 20a.5.5 0 01-.5-.5v-2a.5.5 0 011 0v2a.5.5 0 01-.5.5z"/><path pid="5" d="M12 15.5h1v4h-1zM15.5 16.5h1v3h-1zM16 24a.5.5 0 01-.5-.5v-2a.5.5 0 011 0v2a.5.5 0 01-.5.5zM3 12.254H2v-4.29l3.72-2.136.498.867L3 8.543zM19.221 2.926L16 1.077l-3.22 1.849-.498-.867L16-.077l3.718 2.136zM30 12.254h-1V8.543l-3.218-1.848.497-.867L30 7.964zM26.279 26.173l-.497-.866L29 23.458v-3.71h1v4.29zM16 32.077l-3.718-2.136.498-.866L16 30.923l3.221-1.848.497.866zM5.72 26.173L2 24.038v-4.29h1v3.71l3.218 1.849z"/>'
  }
})
